import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function FAQLinks({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="FAQ" />
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <p>Items below may be helpful to this process.</p>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Application to print</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Application process</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Codebox login</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Del City Inspection </span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Filter Orders</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Keys</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Lockbox Codes</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Pet Policies</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Positive Credit Reporting</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Proof of Income</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Property Inspections</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Rent Payments</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Tenant Performed Repairs</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Utilities</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Vacant property process</span>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button type="primary" onClick={handleComplete} disabled={isDisabled}>Complete</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default FAQLinks;
